import { PaymentModel } from 'src/app/model/PaymentModel';
import { CustomerModel } from 'src/app/model/CustomerModel';
import { ProductModel } from './../model/selfcareproducts';
import { AccountModel } from 'src/app/model/AccountModel';
import {  CyberPaySetTransactionRequest, CyberPaySetTransactionResponse, CyberPayLogModel } from 'src/app/model/CyberPay';
import { Injectable } from '@angular/core';
import { ConfigurationService } from './common/configuration.service';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestFromType } from '../model/CustomerModel';
import { LoanModel } from '../model/LoanModel';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private baseUrl: string;
  Url :string; 

  constructor(private http : HttpClient, private config: ConfigurationService) { }

  setTransaction(model : any)
  {  
 
    this.baseUrl= environment.lteHttpBaseUrl;//                    // this.config.baseUrl;

  this.Url =this.baseUrl + '/api/v1/payment/makepayment';  
 
     
    return this.http.post<any>(this.Url,model);  
   }


getTransaction(tranref : string)
  {  
 
    var getcyberpaytrans=this.config.getCyberPayTrans + tranref;
  
     
    return this.http.get<any>(getcyberpaytrans);  
}  

  cyberPaySetTransaction(model:CyberPaySetTransactionRequest){
    var url = `${environment.cyberPayApiUrl}`;
    return this.http.post<CyberPaySetTransactionResponse>(url,model);
  }

  cyberPayGetTransaction(transactionReference){
    var url = `${environment.cyberPayApiUrl}/${transactionReference}`;
    return this.http.get<CyberPaySetTransactionResponse>(url);
  }

  LteCreditCustomer(operatorcode : number, i_customer : number, i_acc : number, i_prod : number, IsSuccessful:boolean, paymentResponse : CyberPaySetTransactionResponse  ){
    var url = `${environment.lteHttpBaseUrl}/api/payment/cyberpay/creditv2/?operatorcode=${operatorcode}&i_customer=${i_customer}&i_acc=${i_acc}&i_prod=${i_prod}&IsSuccessful=${IsSuccessful}`;

    return this.http.post<any>(url,paymentResponse);

  }
  LteGetCustomerAllocations(i_customer:number, startDate:string, enddate : string){
    var url = `${environment.lteHttpBaseUrl}/api/payment/customer/${i_customer}/allocations?startdate=${startDate}&enddate=${enddate}`;
    return this.http.get<any>(url);
  }

  LteGetAccountAllocations(i_account:number, startDate:string, enddate : string){
    var url = `${environment.lteHttpBaseUrl}/api/payment/account/${i_account}/allocations?startdate=${startDate}&enddate=${enddate}`;
    return this.http.get<any>(url);
  }

  LteRenewPlanAccountRenewal(i_customer:number, i_account:number , amount:number, createBy: string,vatAmount:number=0,vatRate:number=0){
    let acct : AccountModel = {} as AccountModel;
    acct.i_account = i_account;

    let acctList : AccountModel[] = [] as AccountModel[];
    acctList.push(acct);

    let paymentModel : PaymentModel = {} as PaymentModel;
    paymentModel.Amount = amount;
    paymentModel.PaymentAccount = acctList;
    paymentModel.RequestFrom = RequestFromType.WEB;
    paymentModel.CreatedBy="SELFCARE";
    paymentModel.VAT=vatAmount;
    paymentModel.AllocateAll=true;
    paymentModel.VatPercentage=vatRate;
    paymentModel.ProdVatPrice=amount;


    let url = `${environment.lteHttpBaseUrl}/api/payment/customer/buy/${i_customer}/allocate`;
    return this.http.post<any>(url,paymentModel);

  }

  LteTopUp(i_customer:number, i_account:number , amount:number, vatAmount:number,vatRate:number){

    let acct : AccountModel = {} as AccountModel;
    acct.i_account = i_account;

    let acctList : AccountModel[] = [] as AccountModel[];
    acctList.push(acct);

    let paymentModel : PaymentModel = {} as PaymentModel;
    paymentModel.Amount = amount;
    paymentModel.PaymentAccount = acctList;
    paymentModel.RequestFrom = RequestFromType.WEB;
    paymentModel.VAT=vatAmount;
    paymentModel.VatPercentage=vatRate;
    paymentModel.ProdVatPrice=amount;

    let url = `${environment.lteHttpBaseUrl}/api/payment/customer/buy/${i_customer}/allocateextradata`;
    return this.http.post<any>(url,paymentModel);

  }

  LteRenewPlanServiceChange(i_customer:number, i_account:number, i_product: number,mdn : string,amounttotal:number,vatamount:number,vatprod:number, vatRate:number){
    
    let paymentModel : PaymentModel = {} as PaymentModel;
    let productModel : ProductModel = {} as ProductModel;
    let customerModel : CustomerModel = {} as CustomerModel;
    let acct : AccountModel = {} as AccountModel;
    let acctList : AccountModel[]  = [] as AccountModel[];

    productModel.i_product = i_product;
    customerModel.i_customer = i_customer;
    acct.i_account = i_account;
    acctList.push(acct);

    paymentModel.Product = productModel;
    paymentModel.Customer = customerModel;
    paymentModel.RequestFrom = RequestFromType.WEB;
    paymentModel.PaymentAccount = acctList;
    paymentModel.Amount=amounttotal;
    paymentModel.VAT=vatamount;
    paymentModel.VatPercentage=vatRate;
    paymentModel.ProdVatPrice=vatprod;

    let url = `${environment.lteHttpBaseUrl}/api/accounts/${i_account}/allocserviceplan`;
    return this.http.post<any>(url,paymentModel);

  }

  LteGiveLoan(i_customer:number, i_account:number, noofdays: number, operatorcode:number){
    
    let loanModel : LoanModel = {} as LoanModel;
    let customerModel : CustomerModel = {} as CustomerModel;
    let acct : AccountModel = {} as AccountModel;

    customerModel.i_customer = i_customer;
    customerModel.OperatorCode = operatorcode;

    acct.i_account = i_account;
    acct.OperatorCode = operatorcode;


    loanModel.NofoDays = noofdays;
    loanModel.LogActivity = true;
    loanModel.Reason = "";
    loanModel.RequestFrom = RequestFromType.WEB;
    loanModel.Account = acct;
    loanModel.Customer = customerModel;
    

    let url = `${environment.lteHttpBaseUrl}/api/accounts/${i_account}/giveloan`;
    return this.http.post<any>(url,loanModel);

  }

  LteHttpLogCyberPayRequest(model:CyberPayLogModel){
    var url = `${environment.lteHttpBaseUrl}/api/payment/cyberpay/addcyberpayV2requestlog`;
    return this.http.post<any>(url,model);

  }

  LteHttpUpdateLogCyberPayRequest(model:CyberPayLogModel){
    var url = `${environment.lteHttpBaseUrl}/api/payment/cyberpay/updatecyberpayV2requestlog`;
    return this.http.post<any>(url,model);

  }

  LteHttpGetCyberpayRequestLog(transactionReference){
    var url = `${environment.lteHttpBaseUrl}/api/payment/cyberpay/getcyberpayv2log?transRef=${transactionReference}`;
    return this.http.get<any>(url);
  }


  GetVAT(amount){
    var url = `${environment.lteHttpBaseUrl}/api/products/${amount}/vat`;
    return this.http.get<any>(url);
  }
  
}
